import React from 'react';
import './SubscribeSection.css';
import gift from '../Images/gift.mp4'; // Ensure this is correct

const SubscribeSection = () => {
  return (
    <section className="subscribe-section">
      <div className="subscribe-content">
             <div className="subscribe-left">
           <video autoPlay loop muted playsInline className="gift-video">
            <source src={gift} type="video/mp4" />
          </video>
   
       
          <div>
            <h2>Be a Spinelle VIP Member</h2>
            <p>Unlock early access to exclusive diamond collections & special offers tailored just for you.</p>
          </div>
        </div>

        <div className="subscribe-right">
          <input type="email" placeholder="Enter your email address" />
          <button>Join Now</button>
<div className="gender-options">
  <div className="gender-option-item">
    <label><input type="radio" name="gender" /> Female</label>
  </div>
  <div className="gender-option-item">
    <label><input type="radio" name="gender" /> Male</label>
  </div>
  <div className="gender-option-item">
    <label><input type="radio" name="gender" /> Prefer Not to Say</label>
  </div>
</div>

        </div>
      </div>
    </section>
  );
};

export default SubscribeSection;
